import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import { RadioGroup } from 'components/Form'
import { SectionHeader } from 'components/Header'
import { useMediaTypesKindOptions } from 'features/inventory/ad-unit/forms/GeneralForm/sections/MediaTypesSection/hooks/useMediaTypesKindOptions'
import { useAbility } from 'providers/casl'
import { Schema } from '../../schema'
import { DefaultFields } from './components/DefaultFields'
import { ViewportsTable } from './components/ViewportsTable/ViewportsTable'

export const RefreshSizesSection = (): React.JSX.Element => {
  const { t } = useTranslation('features/adUnit', {
    keyPrefix: 'form.refresher.refreshRedirect.columns.refreshSizes',
  })
  const { control } = useFormContext<Schema>()
  const ability = useAbility()
  const cannotUpdateAdUnit = ability.cannot('update', 'AdUnit')
  const kindOptions = useMediaTypesKindOptions()

  const kind = useWatch({
    control,
    name: 'refreshRedirect.mediaTypeRefreshers.kind',
  })

  return (
    <>
      <SectionHeader
        subtitle={t('subtitle')}
        title={t('label')}
      />

      <GapBox />

      <RadioGroup
        control={control}
        disabled={cannotUpdateAdUnit}
        label={t('kind.label')}
        name='refreshRedirect.mediaTypeRefreshers.kind'
        options={kindOptions}
        row
      />

      <GapBox />

      {kind === 'default' ? <DefaultFields /> : <ViewportsTable />}
    </>
  )
}
